(function () {
  angular.module('calendarApp').directive('chooseTimeslotModal', ["API_URL", "$rootScope", function (API_URL, $rootScope) {
    return {
      restrict: 'EA',
      replace: true,
      templateUrl: smooth.calendar_url + '/partials/directives/choose-timeslot-modal.html',
      scope: {
        parentScope: '='
      },
      link: function link(scope, elem, attrs) {
        scope.timeslot = scope; // So that this scope can be inherited by descendants

        scope.parentScope.chooseTimeslots = function (shift) {
          scope.shift = shift;
          scope.initTimeslots(shift); // User must log in before continuing

          scope.userLoggedIn = $rootScope.customerInfo && $rootScope.customerInfo.firstname;
          scope.timeSettings = $rootScope.timeSettings;
          scope.clearRegoData();
          $('#choose-timeslot-modal').modal('show');
        }; // end chooseTimeslots


        scope.continue = function () {// Whether to choose future timeslots
        };
      }
    };
  }]);
})();